import { Component, Input } from '@angular/core';

import { AsyncJobViewModel } from '../../async-job-view.types';

@Component({
  selector: 'rt-async-jobs-progress-display',
  templateUrl: './async-jobs-progress-display.component.html',
  styleUrls: ['./async-jobs-progress-display.component.less'],
  standalone: true,
})
export class AsyncJobsProgressDisplayComponent {
  @Input() public title: string;
  @Input() public message: string | undefined;
  @Input() public job: AsyncJobViewModel;
}
